import { useEffect, useState } from 'react';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { useFormik } from 'formik';
import * as yup from "yup"
import { Box, Button, Divider, Typography } from '@mui/material';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import BpRadio from '../../bp-radio/BpRadio'
import Breadcrumb from '../../../../UI/breadcrumb/breadcrumb';
import './select-form-type.scss';

const getWindowSize = () => {
  const innerWidth = window.innerWidth;
  return innerWidth;
}

const SelectTypeForm = () => {
  const { state } = useLocation()
  const { file }: any = state||{};
  const navigate = useNavigate();

  const [windowSize, setWindowSize] = useState(getWindowSize());
  const initialValues = {
    formType: "",
  }

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize(getWindowSize());
    }
    window.addEventListener('resize', handleWindowResize);
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, [windowSize])


  const validationSchema = yup.object().shape({
    formType: yup.string().required("Please Select Form Type"),
  })

  const { values, errors, touched, handleChange, handleSubmit } =
    useFormik({
      initialValues,
      validationSchema,
      onSubmit: () => {
          navigate(`/appeal-process/${values.formType}`, { state: { file: file } })
       },
    });

  const tempArray = [
    { name: "My Appeal ", onClickNavigateTo: "/appeal-process", color: "black" },
    { name: " Dashboard", onClickNavigateTo: "/", color: "#00BCD4", },
    { name: " / List of PCN's", onClickNavigateTo: "/pcn", color: "#00BCD4" },
    { name: ` / Select Type`, onClickNavigateTo: `/pcn's/list/select-type`, color: "#434242" },
  ];

  return (
    <>
      <Box>
        <Breadcrumb breadCrumbData={tempArray} />
      </Box>
      <Box className="select-type-form">
        <p className="form-heading">Form Type</p>
        <Divider sx={{ margin: "1rem 0" }} />

        <form onSubmit={handleSubmit}>
          <Box
            sx={{
              display: 'inline-flex',
              flexDirection: "column",
              alignItems: 'flex-start',
              '& > :not(style)': { m: 1 },
            }}>
            <FormControl>
              <label>Was the notice</label>
              <RadioGroup
                onChange={handleChange}
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue=""
                name="formType">
                <FormControlLabel value="informal" control={<BpRadio />} label="Informal Appeal" />
                <FormControlLabel value="formal" control={<BpRadio />} label="Formal Appeal" />
                <FormControlLabel value="independent-adjudicator" control={<BpRadio />} label="Indpendent Adjudicator Appeal" />
              </RadioGroup>
            </FormControl>
            {errors.formType && touched.formType && (
              <Typography className='error-color'>
                {errors.formType}
              </Typography>
            )}

            <Box className='flex-box'>
              <Button type='submit' variant="contained" className='btn-white'><Link className='link' to={"/appeal-process"}>Back</Link></Button>

              <Button type='submit' className='btn-primary' variant="contained" disabled={values.formType===''}>
                Proceed
                {values.formType &&
                  <></>
                }
              </Button>
            </Box>
          </Box>
        </form >
      </Box >
    </>
  )
}

export default SelectTypeForm